import PageHero from '../components/PageHero';
import SectionIntro from '../components/SectionIntro';
import InfoCard from '../components/InfoCard';
import ProcessList from '../components/ProcessList';
import Button from '../components/Button';
import { homeImages, partnerBenefits, partnerTypes, partnershipModel, processSteps } from '../data/siteData';

export default function PartnershipsPage() {
  return (
    <>
      <PageHero
        eyebrow="Partnerships"
        title="Collaboration is at the heart of progress"
        description="Together, we advance science, expand opportunity, and create meaningful impact in communities."
        image={homeImages.partnerships}
        compact
      />

      <section className="section shell">
        <SectionIntro eyebrow="Our Partnership Model" title="Collaborate, innovate, empower, and measure impact" align="center" />
        <div className="mini-card-grid mini-card-grid--four top-gap-lg">
          {partnershipModel.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="mini-card mini-card--tall">
                <Icon size={34} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="shell">
          <SectionIntro
            eyebrow="Partner With Us"
            title="Organizations across sectors can help strengthen the clinical research ecosystem"
            text="We partner with organizations across sectors to build a healthier, more equitable future."
            align="center"
          />
          <div className="card-grid card-grid--four top-gap-lg">
            {partnerTypes.map((item) => (
              <InfoCard key={item.title} icon={item.icon} title={item.title} text={item.text} />
            ))}
          </div>
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro eyebrow="Partner Benefits" title="What partners gain by working with BrainTorch™ Bio" align="center" />
        <div className="benefit-row top-gap-md">
          {partnerBenefits.map((benefit) => (
            <span key={benefit}>✓ {benefit}</span>
          ))}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="shell split-layout">
          <SectionIntro
            eyebrow="How to Partner"
            title="Partner with BrainTorch™ Bio"
            text="BrainTorch™ Bio collaborates with employers, workforce organizations, and educational institutions to build workforce pipelines, including internship pathways, training placements, program collaborations, and grant or funding partnerships."
          />
          <ProcessList steps={processSteps} />
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Let’s build stronger together.</h2>
            <p>Join us in advancing science and empowering minds through strategic partnerships.</p>
          </div>
          <Button to="/contact#contact-connect" variant="teal">Become a Partner</Button>
        </div>
      </section>
    </>
  );
}
